// src/components/UWNetIDHelp.js
import React from 'react';

const UWNetIDHelp = () => {
  return (
    <div className="uw-netid-help">
      <p>
        Learn about account recovery options
        <br />
        Learn about UW NetIDs
        <br />
        Learn about UW NetID sign-in
        <br />
        Obtain a UW NetID
      </p>
    </div>
  );
};

export default UWNetIDHelp;